module.exports = __webpack_public_path__ + "static/image/history/pc/201908@3x.ver2_0_2.jpg?134cfa90";